import { useQuery } from "@tanstack/react-query";
import { getAccountSettings } from "../api/settingsApi";

export const useUserPreferences = () => {
  const { data: accountData, isLoading } = useQuery({
    queryKey: ["accountSettings"],
    queryFn: getAccountSettings,
  });

  return {
    firstName: accountData?.user?.firstName || "",
    lastName: accountData?.user?.lastName || "",
    fullName:
      accountData?.user?.firstName && accountData?.user?.lastName
        ? `${accountData.user.firstName} ${accountData.user.lastName}`
        : accountData?.user?.firstName || "",
    currency: accountData?.user?.currency || "CAD",
    timeFormat: accountData?.user?.timeFormat || "12h",
    is12HourClock: (accountData?.user?.timeFormat || "12h") === "12h",
    isLoading,
  };
};
